<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.7499 1L18.9999 3.25L16.7499 5.5L18.9999 7.75L16.7499 10L18.9999 12.25L16.7499 14.5L18.9999 16.75L16.7499 19L14.4999 16.75L12.2499 19L9.99988 16.75L7.74988 19L5.49988 16.75L3.24988 19L0.999878 16.75L3.24988 14.5L0.999878 12.25L3.24988 10L0.999878 7.75L3.24988 5.5L0.999878 3.25L3.24988 1L5.49988 3.25L7.74988 1L9.99988 3.25L12.2499 1L14.4999 3.25L16.7499 1Z"
      fill="currentColor"
    />
  </svg>
</template>
